import {
    createDataActionFactory,
    HubPersona,
    Feature,
    createThunk,
    ThunkDispatch,
} from '../../../shared';
import { searchSuggestedPersonas } from '../../datalayer/getSearchSuggestions';
import { QueryData, QuerySource } from '../../models/query';
import { getPackageState } from '../../../appstate';
import { packageStateKey, SearchBoxState } from '../../state';

export const getRecipientCacheSuggestionsCompletedAction = createDataActionFactory<
    { query: string; suggestions: HubPersona[] },
    { query: string; error: Error }
>('GetRecipientCacheSuggestionsCompletedAction', Feature.Search);

export const getSearchSuggestions = createThunk(
    'GetSearchSuggestions',
    (dispatch: ThunkDispatch, getState: () => {}) => (queryData: QueryData) => {
        const state = getPackageState<SearchBoxState>(getState(), packageStateKey);
        if (
            !state.appState.data.searchState.recipientCacheSuggestions[queryData.currentQueryString]
        ) {
            const rootContactFolderId =
                state.appState.data.contactFoldersState?.rootContactFolder?.id;

            if (!!rootContactFolderId) {
                searchSuggestedPersonas({
                    ...queryData,
                    isAllFolder: true,
                    source: QuerySource.RecipientCacheSuggestions,
                    folderId: rootContactFolderId,
                    internalFolderId: rootContactFolderId,
                })
                    .then(suggestions =>
                        dispatch(
                            getRecipientCacheSuggestionsCompletedAction.success({
                                query: queryData.currentQueryString,
                                suggestions,
                            })
                        )
                    )
                    .catch(error =>
                        dispatch(
                            getRecipientCacheSuggestionsCompletedAction.error({
                                query: queryData.currentQueryString,
                                error,
                            })
                        )
                    );
            }
        }
    }
);
export type { DataActionFactory } from '../../../shared';
export type { Action } from '../../../shared';
